import { useNavigate } from "react-router-dom";
import { MESSAGES } from "../constants/const";
import { useContext, useEffect } from "react";
import { showErrorMessage } from "../components/appPane";
import { REQ_LOGOUT, useApi } from "./classApi";
import { LoginContext } from "../context/loginContext";
import useCookie from "./cookie";

/** 各ページと権限の対応 */
export const PAGE = {
  MANAGEMENT: 0,
  HOME: 1,
  ORDER: 2,
};

/**
 * 権限管理
 * @param page 表示対象ページ
 * @returns
 */
export function usePermission(page: number) {
  const navigate = useNavigate();
  const [cookieData, cookieHandle] = useCookie();

  // 各種権限
  const permissions = [cookieData.permission1, cookieData.permission2, cookieData.permission3];

  // 対象ページの表示可否
  const canDisplay = permissions[page] > 0;
  // 対象ページの編集可否
  const canEdit = permissions[page] > 1;
  // 発注管理画面の表示可否
  const canDisplayOrder = permissions[PAGE.ORDER] > 0;
  // 発注管理画面の編集可否
  const canEditOrder = permissions[PAGE.ORDER] > 1;
  // ホーム画面での実績入力可否（運転員の判定）
  const canEditOrderResult = Number(cookieData.permissionId) === 4;

  const { postRequestJson } = useApi(window);
  const { setIsLogin } = useContext(LoginContext);

  // ログアウト処理
  const logout = async () => {
    await postRequestJson(REQ_LOGOUT);
    cookieHandle.deleteCookies();
    setIsLogin(false);
    window.history.pushState({}, "", "/");
  };

  // 表示可能なページ取得
  const showablePagePath = () => {
    if (permissions[PAGE.HOME] > 0) return "/home";
    if (permissions[PAGE.ORDER] > 0) return "/orderlist";
    if (permissions[PAGE.MANAGEMENT] > 0) return "/management";
  };

  // 表示可能ページへリダイレクト
  const redirect = async () => {
    if (!canDisplay) {
      const path = showablePagePath();
      if (path) navigate(path);
      else {
        // 遷移先がない場合はエラー表示してログアウト
        await showErrorMessage(MESSAGES.ERROR_PERMISSION);
        logout();
      }
    }
  };

  // 画面初期表示時
  useEffect(() => {
    if (!canDisplay) redirect();
  }, []);

  return [{ canDisplay, canEdit, canDisplayOrder, canEditOrder, canEditOrderResult }, { redirect }];
}
